import { Button, TextField } from '@statsbomb/kitbag-components';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { styled } from 'styled-components';
import themeHelper from '../../utils/themeHelper';

const Container = styled.div`
  display: flex;
  gap: ${themeHelper.spacing()};
`;

export function PlaySearchBox({ isPending, setPlays }) {
  const intl = useIntl();

  const [playString, setPlayString] = useState();

  const submit = () => {
    setPlays(playString?.toString()?.split(','));
  };

  return (
    <Container>
      <TextField
        id="metadata-plays"
        onChange={(event) => setPlayString(event.target.value)}
        placeholder={intl.formatMessage({
          defaultMessage: 'Comma separated list of plays',
          id: 'ddb6d',
        })}
        value={playString}
        variant="secondary"
      />
      <Button onClick={submit} isPending={isPending}>
        <FormattedMessage defaultMessage="Submit" id="a4d3b" />
      </Button>
    </Container>
  );
}

PlaySearchBox.propTypes = {
  isPending: PropTypes.bool,
  setPlays: PropTypes.func.isRequired,
};
PlaySearchBox.defaultProps = {
  isPending: false,
};

export default { PlaySearchBox };
